export default __webpack_public_path__ + "static/media/Report.d03b826c.svg";